import { NavigationBarConfig } from '../models/nav-bar-item.model'; // Adjust the import path as necessary

export const navBarConfig = (): NavigationBarConfig => ({
  navItems: [
    // { label: 'Dashboard', icon: 'icon-dashboard', path: '/' },
    {
      label: 'New Customer',
      icon: 'icon-add-account',
      path: '/new',
      subItems: [
        {
          icon: 'icon-add-account',
          label: 'New Account',
          path: '/new/new-account'
        },
        {
          icon: 'icon-users',
          label: 'Bulk Import',
          path: '/new/bulk-upload'
        }
      ]
    },
    { label: 'Account Search', icon: 'icon-account-search', path: '/account' },
    {
      label: 'Support',
      icon: 'icon-support',
      path: '/support',
      subItems: [
        {
          icon: 'icon-transfer',
          label: 'Transfer Students',
          path: '/support/transfer-students'
        },
        {
          icon: 'icon-undo',
          label: 'Undelete Students',
          path: '/support/undelete-account'
        },
        {
          icon: 'icon-support',
          label: 'Add Clever',
          path: '/support/add-clever-account'
        }
      ]
    },
    {
      label: 'Reports',
      icon: 'icon-report',
      path: '/reports',
      subItems: [
        {
          icon: 'icon-trial',
          label: 'Free Trials',
          path: '/reports/free-trials'
        }
      ]
    },
    // Its own page, not an Angular route - built from explorer/ and served from /explorer/.
    // See pipelines/templates/build-explorer.yml for how it gets there.
    {
      label: 'Nessy Explorer',
      icon: 'icon-book',
      path: '/explorer/',
      isExternal: true,
      badge: 'Experimental'
    },
    // {
    //   label: 'Feature Flags',
    //   icon: 'icon-flag',
    //   path: '/',
    // },
    {
      label: 'Settings',
      icon: 'icon-settings',
      path: '/settings'
    }
  ]
});

export const policyLinks = [
  {
    link: '/cookies',
    text: 'Cookies',
    isRouterLink: true
  },
  {
    link: 'https://www.nessy.com/en-gb/shop/data-privacy-legal',
    text: 'Privacy Policy'
  },
  {
    link: 'https://www.nessy.com/en-gb/shop/data-privacy-legal/terms-conditions',
    text: 'Terms and Conditions'
  },
  {
    link: 'https://www.nessy.com/en-gb/about-us/help-support',
    text: 'Help and Support '
  }
];
